export default __webpack_public_path__ + "static/media/phone-cancel.809ebd2c.svg";